import { Webhook } from 'lucide-react';
import { msg } from '@/lib/i18n';
import { registerInvalidation } from '@/lib/realtime';
import { registerEntityHref } from '@/ui';
import { defineModule } from '../types';
import { integrationsKeys } from './api';
import { integrationsRoute } from './routes';

/**
 * Integrations (IA §2 Manage › Admin › Integrations): notify *systems* (R-28). Outbound webhooks —
 * endpoints, their event subscriptions, test pings, secrets shown once, and the delivery log.
 */
export const integrationsModule = defineModule({
  key: 'integrations',
  routes: [integrationsRoute],
  nav: [
    {
      key: 'integrations',
      label: msg('Integrations'),
      description: msg('Which systems are told what, and did it arrive?'),
      icon: Webhook,
      to: '/admin/integrations',
      section: 'manage',
      order: 112,
      permission: 'integrations.webhook.read',
      module: 'integrations',
    },
  ],
  setup() {
    registerEntityHref('webhook', (id) => `/admin/integrations?webhook=${id}`);
    // every integrations event is about a webhook (subject type "webhook")
    registerInvalidation('webhook', () => [integrationsKeys.all]);
  },
});
